import { Platform, View } from "react-native";
import { Text } from "react-native-paper";
import LottieView from "lottie-react-native";

import type { ScreenProps } from ".";
import { ActionsContainer, IconButton, ScreenContainer, Button } from "../../components";
import useIntercom from "../../hooks/useIntercom";

export default function SuccessScreen({ navigation }: ScreenProps<"Success", "root">) {
  function onClose() {
    navigation.canGoBack() ? navigation.goBack() : navigation.getParent("root")?.navigate("Main", { screen: "DeferredComp" });
  }

  useIntercom({ onFocus: { event: "viewed-enrollment-success" } });

  return (
    <ScreenContainer>
      {Platform.OS !== "web" && <IconButton icon="x" onPress={onClose} className="mt-12" />}
      <View className="items-center justify-center my-4 sm:my-16 grow max-w-3xl mx-auto w-full">
        <View className="w-40 h-40">
          <LottieView
            style={{ flex: 1 }}
            autoPlay
            loop={false}
            source={require("../../../assets/lottie-icons/verified.json")}
          />
        </View>
        <Text className="text-title-2 font-700 mt-10">You're enrolled!</Text>

        <Text className="text-regular-normal font-400 mt-6 mx-8 text-center">
          Well done! You've successfully enrolled in the Deferred Compensation program, and you're ready to start earning
          points. Tap the button below to return to your account dashboard.
        </Text>
      </View>

      <ActionsContainer>
        <Button mode="secondary" onPress={onClose}>
          Close
        </Button>
      </ActionsContainer>
    </ScreenContainer>
  );
}
